const circleBtnStyle = {
  circleBtnContainer: {
    position: "relative",
    width: 45,
    height: 45,
    position: "fixed",
    bottom: 9,
    right: 9,
    color: "white",
    borderRadius: "50%",
    backgroundColor: "#87ceeb",
    transition: "all .5s ease",
    boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.6)",
    "&:hover": {
      boxShadow: "0 3px 9px 0px rgba(0, 0, 0, 0.6)",
      transform: "scale(1.01, 1.01)",
    },
  },
  icon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: 33,
  },
};
export default circleBtnStyle;
